export const routes = {
	bookingForm: "bookingForm",
	intro: "intro",
	selectCenter: "selectCenter",
	damageGlass: "damageGlass",
	damageType: "damageType",
	damageArea: "damageArea",
	selectDateTime: "selectDateTime",
	bookingEnd: "bookingEnd",
	thankYouPage: "thankYouPage",
	loader: "loader",
	contactForm: "contactForm",
	errorPage: "errorPage",
};

export const FALLBACK_LANG = "es-ES";
export const LANG =
	new URLSearchParams(window.location.search)
		.get("lang")
		?.replace("_", "-") || FALLBACK_LANG;

export const glassItems = [
	{
		id: "R4",
		glassName: "Lateral derecho trasero fijo",
		className: "item right",
		areaPoints:
			"316.5 240.71 297 243.71 301.5 258.71 306.5 266.71 329.5 274.21 339 262.21 353 237.71 316.5 240.71",
		glassPath:
			"M309.8,266.22c-.81,0-1.55-.26-2.08-.74-2.4-2.15-6.03-8.42-9.02-19.58-.25-.93-.4-1.48-.06-1.99s.91-.59,1.86-.72l12.54-1.78c.49-.07.88-.12,1.19-.12.27,0,.66.03.98.33.47.45.42,1.09.32,2.16-1.05,11.8-2.39,18.55-3.29,20.93-.36.94-1.29,1.52-2.44,1.52Z",
	},
	{
		id: "R3",
		glassName: "Lateral derecho trasero descendente",
		className: "item right",
		areaPoints:
			"321 195 293 203.5 293 215 295 233.5 297 243 316 240 353 236.5 353 189.5 339.5 190.5 326.5 193.5 321 195",
		glassPath:
			"M298.82,241.49c-.31,0-.55-.07-.76-.21-.45-.31-.55-.79-.72-1.6-2.15-10.31-3.21-20.68-3.42-33.61-.01-.7-.02-1.12.26-1.49.28-.37.68-.48,1.35-.66l20.47-5.61c.7-.19,1.17-.32,1.56-.32.32,0,.58.08.79.26.54.44.5,1.11.42,2.32-.83,13.08-1.73,25.38-2.69,36.53-.06.7-.09,1.12-.41,1.46-.32.34-.73.41-1.42.52l-14.42,2.3c-.43.07-.74.12-1.01.12h0Z",
	},
	{
		id: "R2",
		glassName: "Lateral derecho delantero descendente",
		className: "item right",
		areaPoints:
			"325.5 139 301.5 148 297 158.5 293.5 175.5 292.5 200 321 191.5 327 190 340 187.5 353.5 186.5 353.5 139 325.5 139",
		glassPath:
			"M295.16,197.21c-.25,0-.48-.07-.67-.2-.59-.41-.58-1.11-.57-2.38.17-17.92,1.15-23.9,4.67-36.61.57-2.07,1.46-4.48,2.63-7.15.53-1.21.82-1.87,1.39-2.41.57-.54,1.23-.79,2.56-1.3l13.95-5.33c.81-.31,1.34-.51,1.79-.51.27,0,.5.07.7.22.59.43.55,1.15.49,2.46-.62,12.27-1.39,26.12-2.35,42.32-.03.58-.05.93-.29,1.25-.23.32-.56.45-1.1.66l-21.45,8.46c-.79.31-1.31.52-1.76.52Z",
	},
	{
		id: "R1",
		glassName: "Lateral derecho delantero fijo",
		className: "item right",
		areaPoints:
			"326 138 303.5 146.5 301.5 145.5 311.5 125.5 325 107 353.5 104 353.5 138 326 138",
		glassPath:
			"M305.44,144.77c-.32,0-.52-.14-.62-.26-.43-.48-.13-1.04.42-2.06,3.78-6.99,9.33-16.55,14.31-22.43,1.17-1.39,1.76-2.08,2.5-2.08.13,0,.27.03.4.08.9.36.85,1.41.74,3.5-.1,2.06-.21,4.34-.33,6.72-.13,2.73-.27,5.59-.41,8.42-.03.59-.05.94-.28,1.26-.23.32-.55.45-1.1.67l-14.15,5.74c-.7.28-1.12.46-1.48.46h0Z",
	},
	{
		id: "L4",
		glassName: "Lateral izquierdo trasero fijo",
		className: "item left",
		areaPoints:
			"77.5 240.5 97 243.5 92.5 258.5 87.5 266.5 64.5 274 55 262 41 237.5 77.5 240.5",
		glassPath:
			"M84.1,266.5c-1.15,0-2.09-.58-2.44-1.52-.9-2.38-2.24-9.12-3.29-20.93-.09-1.06-.15-1.71.32-2.16.32-.3.71-.33.98-.33.32,0,.7.05,1.19.12l12.54,1.78c.96.14,1.53.22,1.87.72.33.51.19,1.06-.06,1.99-3,11.17-6.62,17.44-9.02,19.59-.53.48-1.27.74-2.08.74Z",
	},
	{
		id: "L3",
		glassName: "Lateral izquierdo trasero descendente",
		className: "item left",
		areaPoints:
			"73 195 101 203.5 101 215 99 233.5 97 243 78 240 41 236.5 41 189.5 54.5 190.5 67.5 193.5 73 195",
		glassPath:
			"M95.08,241.77c-.27,0-.57-.05-1-.12l-14.42-2.3c-.7-.11-1.11-.18-1.43-.52-.32-.34-.35-.76-.41-1.46-.96-11.19-1.87-23.48-2.69-36.53-.08-1.21-.12-1.88.42-2.32.22-.18.48-.26.79-.26.4,0,.86.13,1.56.32l20.46,5.61c.68.19,1.08.3,1.36.67.28.37.27.79.26,1.49-.22,12.93-1.28,23.29-3.43,33.61-.17.81-.27,1.3-.72,1.61-.21.15-.45.21-.76.21Z",
	},
	{
		id: "L2",
		glassName: "Lateral izquierdo delantero descendente",
		className: "item left",
		areaPoints:
			"68.5 139 92.5 148 97 158.5 100.5 175.5 101.5 200 73 191.5 67 190 54 187.5 40.5 186.5 40.5 139 68.5 139",
		glassPath:
			"M98.66,197.21c-.45,0-.97-.21-1.76-.52l-21.45-8.46c-.54-.21-.87-.34-1.1-.66-.23-.32-.25-.67-.29-1.25-.96-16.24-1.73-30.08-2.35-42.33-.07-1.31-.1-2.03.49-2.46.2-.14.43-.22.7-.22.45,0,.98.2,1.79.51l13.95,5.32c1.34.51,2,.77,2.57,1.31.57.54.86,1.2,1.39,2.41,1.18,2.68,2.06,5.08,2.64,7.15,3.52,12.7,4.49,18.69,4.66,36.6.01,1.28.02,1.98-.57,2.39-.19.13-.42.2-.67.2Z",
	},
	{
		id: "L1",
		glassName: "Lateral izquierdo delantero fijo",
		className: "item left",
		areaPoints:
			"68 138 90.5 146.5 92.5 145.5 82.5 125.5 69 107 40.5 104 40.5 138 68 138",
		glassPath:
			"M88.3,144.34c-.35,0-.78-.17-1.48-.46l-14.15-5.74c-.54-.22-.87-.35-1.1-.67-.23-.32-.25-.67-.28-1.26-.14-2.84-.28-5.7-.41-8.43-.11-2.38-.22-4.65-.33-6.71-.1-2.09-.16-3.14.74-3.5.13-.05.26-.08.4-.08.74,0,1.33.69,2.5,2.08,3.99,4.72,8.8,12.27,14.3,22.43.55,1.02.86,1.58.42,2.07-.11.12-.3.26-.62.26Z",
	},
	{
		id: "C3",
		glassName: "Luneta trasera",
		className: "item center",
		glassPath:
			"M196.91,313.67c-39.12,0-44.96-7.63-44.96-12.19,0-1.65.37-5.96.92-12.49.66-7.74,1.56-18.34,2.38-30.75.07-1.04.95-1.86,2-1.86.18,0,.35.02.52.07,8.29,2.21,22.92,4.58,39.13,4.58,21.09,0,36.43-3.81,39.29-4.58.17-.04.35-.07.52-.07,1.05,0,1.93.82,2,1.86.82,12.41,1.72,23.01,2.38,30.75.56,6.52.92,10.83.92,12.49,0,4.55-5.86,12.19-45.12,12.19Z",
		detailPath:
			"M238.16,300.86c.07.88.03,1.87-.67,2.86-.7,1-2.08,2.04-4.75,2.98-5.34,1.87-15.75,3.31-35.83,3.31v.37c20.08,0,30.54-1.43,35.95-3.33,2.71-.95,4.17-2.02,4.93-3.11.77-1.1.81-2.18.73-3.11l-.37.03ZM235.56,264.38c.66,9.36,2.36,33.58,2.6,36.49l.37-.03c-.24-2.9-1.95-27.12-2.6-36.48l-.37.03ZM234.87,261.47c.24.2.39.48.49.95.1.47.14,1.1.2,1.96l.37-.03c-.06-.85-.11-1.51-.21-2.01-.11-.51-.28-.89-.62-1.16l-.23.29ZM231.87,261.43c.86-.13,1.49-.23,1.97-.23.48,0,.79.07,1.03.27l.23-.29c-.34-.27-.75-.36-1.27-.35-.52,0-1.17.11-2.02.24l.06.36ZM214.99,263.85c2.83-.3,11.78-1.64,16.87-2.42l-.06-.36c-5.1.78-14.03,2.12-16.86,2.41l.04.37ZM196.91,267.25c9.45,0,13-.74,14.69-1.56.85-.41,1.24-.85,1.62-1.17.19-.16.39-.3.66-.41.27-.11.62-.2,1.11-.25l-.04-.37c-.52.05-.9.15-1.21.28-.31.13-.54.29-.75.47-.42.35-.75.74-1.55,1.12-1.6.78-5.07,1.52-14.53,1.52v.37ZM155.46,300.83c-.08.92-.05,2.01.71,3.1.75,1.09,2.19,2.16,4.88,3.11,5.37,1.9,15.79,3.33,35.87,3.33v-.37c-20.08,0-30.44-1.44-35.75-3.31-2.65-.94-4.01-1.97-4.7-2.98-.68-.99-.72-1.98-.64-2.87l-.37-.03ZM158.06,264.35c-.66,9.36-2.36,33.58-2.6,36.48l.37.03c.24-2.91,1.95-27.13,2.6-36.49l-.37-.03ZM158.89,261.18c-.34.27-.51.65-.62,1.16-.11.5-.15,1.16-.21,2.01l.37.03c.06-.86.11-1.49.2-1.96.1-.47.25-.75.49-.95l-.23-.29ZM162.18,261.07c-.85-.13-1.5-.23-2.02-.24-.52,0-.93.08-1.27.35l.23.29c.24-.2.55-.28,1.03-.27.48,0,1.11.1,1.97.23l.06-.36ZM179.03,263.48c-2.82-.3-11.76-1.64-16.86-2.41l-.06.36c5.09.78,14.04,2.12,16.87,2.42l.04-.37ZM196.91,266.88c-9.46,0-12.88-.75-14.45-1.52-.78-.38-1.09-.77-1.49-1.12-.2-.18-.43-.34-.74-.47-.31-.13-.69-.23-1.21-.28l-.04.37c.49.05.84.14,1.1.25.26.11.45.25.64.41.37.32.74.76,1.57,1.17,1.65.82,5.16,1.56,14.61,1.56v-.37ZM238.35,300.85l.18-.02-.18.02ZM235.74,264.36h.18s-.18,0-.18,0ZM231.84,261.25l-.03-.18h0l.03.18ZM214.97,263.66l.02.18-.02-.18ZM155.64,300.85l-.18-.02.18.02ZM158.24,264.36h-.18s.18,0,.18,0ZM162.15,261.25l.03-.18h0l-.03.18ZM179.01,263.66l-.02.18.02-.18Z",
	},
	{
		id: "C2",
		glassName: "Techo solar o panorámico",
		className: "item center",
		glassPath:
			"M175.83,232.08c-4.94,0-7.42,0-9.06-1.64-1.64-1.64-1.64-4.12-1.64-9.06v-42.5c0-4.94,0-7.42,1.64-9.06s4.12-1.64,9.06-1.64h42.5c4.94,0,7.42,0,9.06,1.64s1.64,4.12,1.64,9.06v42.5c0,4.94,0,7.42-1.64,9.06-1.64,1.64-4.12,1.64-9.06,1.64h-42.5Z",
		detailPath:
			"M215.35,171.84c2.41,0,4.2,0,5.57.19,1.37.18,2.3.55,3,1.25l.26-.26c-.79-.79-1.81-1.17-3.22-1.36-1.4-.19-3.22-.19-5.62-.19v.37ZM225.73,181.86c0-2.4,0-4.22-.19-5.62-.19-1.41-.57-2.43-1.36-3.22l-.26.26c.71.71,1.07,1.64,1.25,3,.18,1.37.19,3.16.19,5.57h.37ZM215.35,228.79c2.4,0,4.22,0,5.62-.19,1.41-.19,2.43-.57,3.22-1.36l-.26-.26c-.71.71-1.64,1.07-3,1.25-1.37.18-3.16.19-5.57.19v.37ZM225.36,218.4c0,2.41,0,4.2-.19,5.57-.18,1.37-.55,2.3-1.25,3l.26.26c.79-.79,1.17-1.81,1.36-3.22.19-1.4.19-3.22.19-5.62h-.37ZM168.42,218.4c0,2.4,0,4.22.19,5.62.19,1.41.57,2.43,1.36,3.22l.26-.26c-.71-.71-1.07-1.64-1.25-3-.18-1.37-.19-3.16-.19-5.57h-.37ZM178.8,228.42c-2.41,0-4.2,0-5.57-.19-1.37-.18-2.3-.55-3-1.25l-.26.26c.79.79,1.81,1.17,3.22,1.36,1.4.19,3.22.19,5.62.19v-.37ZM178.8,171.47c-2.4,0-4.22,0-5.62.19-1.41.19-2.43.57-3.22,1.36l.26.26c.71-.71,1.64-1.07,3-1.25,1.37-.18,3.16-.19,5.57-.19v-.37ZM168.79,181.86c0-2.41,0-4.2.19-5.57.18-1.37.55-2.3,1.25-3l-.26-.26c-.79.79-1.17,1.81-1.36,3.22-.19,1.4-.19,3.22-.19,5.62h.37ZM178.8,171.84h36.55v-.37h-36.55v.37ZM168.79,218.4v-36.55h-.37v36.55h.37ZM215.35,228.42h-36.55v.37h36.55v-.37ZM225.36,181.86v36.55h.37v-36.55h-.37Z",
		detailRect: { x: "165.63", y: "210.14", width: "62.89", height: ".37" },
	},
	{
		id: "C1",
		glassName: "Parabrisas delantero",
		className: "item center",
		glassPath:
			"M238.79,156.43c-.25,0-.5-.05-.74-.14-2.81-1.08-17.98-6.45-41.14-6.45-17.82,0-32.85,3.33-40.98,6.45-.24.09-.49.14-.74.14-1.02,0-1.87-.72-2.03-1.71-3.55-22.62-8.15-39.28-9.47-43.85-.33-1.16-.52-1.79-.53-2.79-.01-1,.08-1.32.23-1.9,2.75-10.29,18.26-21.28,53.52-21.28,45.67,0,52.72,17.73,53.68,21.28.16.58.24.9.23,1.9,0,1-.19,1.64-.53,2.79-1.32,4.57-5.92,21.25-9.47,43.85-.16.99-1.01,1.71-2.03,1.71Z",
		detailPath:
			"M190.49,127.22h13.01v-.37h-13.01v.37ZM205.2,130.84c.57,0,1.03-.46,1.03-1.03h-.37c0,.37-.3.67-.67.67v.37ZM206.23,129.59c0-1.51-1.22-2.73-2.73-2.73v.37c1.31,0,2.37,1.06,2.37,2.37h.37ZM206.23,129.8v-.21h-.37v.21h.37ZM197.76,130.84h7.44v-.37h-7.44v.37ZM197.95,132.99v-2.34h-.37v2.34h.37ZM244.74,109.96c-5.97-2.74-22.78-9.24-47.82-9.24v.37c24.97,0,41.74,6.49,47.67,9.21l.15-.33ZM246.75,111.38c-.15-.32-.38-.55-.71-.76-.32-.21-.75-.4-1.3-.65l-.15.33c.56.26.96.44,1.26.63.29.18.47.37.58.61l.33-.16ZM246.52,113.95c.17-.62.3-1.1.35-1.5.05-.4.03-.74-.12-1.07l-.33.16c.11.24.14.5.09.86-.05.37-.17.83-.34,1.46l.36.1ZM246.51,113.95h0s-.36-.1-.36-.1h0s.36.1.36.1ZM239.45,146.04c1.18-6.36,3.95-20.59,7.07-32.09l-.36-.1c-3.13,11.51-5.89,25.75-7.08,32.12l.36.07ZM238.35,148.93c.33-.23.53-.57.68-1.04.15-.46.26-1.07.41-1.85l-.36-.07c-.15.8-.26,1.37-.4,1.81-.14.43-.3.68-.54.85l.21.3ZM235.27,148.93c.78.14,1.39.25,1.87.27.49.02.87-.04,1.21-.28l-.21-.3c-.24.17-.54.23-.98.21-.45-.02-1.03-.12-1.82-.26l-.06.36ZM207.94,144.22c4.43.66,20.33,3.47,27.34,4.71l.06-.36c-7-1.24-22.91-4.06-27.35-4.72l-.05.36ZM197.76,133.17c2.63,0,4.18.63,5.14,1.56.96.93,1.36,2.18,1.61,3.5.13.66.21,1.32.32,1.97.11.64.23,1.26.44,1.82.2.56.49,1.05.92,1.44.43.39,1,.65,1.75.76l.05-.36c-.69-.1-1.18-.34-1.55-.67-.37-.33-.63-.77-.82-1.29-.19-.52-.31-1.11-.42-1.75-.1-.63-.19-1.31-.32-1.98-.25-1.34-.67-2.69-1.72-3.7-1.05-1.01-2.71-1.66-5.4-1.66v.37ZM188.79,130.47c-.37,0-.67-.3-.67-.67h-.37c0,.57.46,1.03,1.03,1.03v-.37ZM188.12,129.59c0-1.31,1.06-2.37,2.37-2.37v-.37c-1.51,0-2.73,1.22-2.73,2.73h.37ZM188.12,129.8v-.21h-.37v.21h.37ZM196.22,130.47h-7.44v.37h7.44v-.37ZM197.76,130.47h-1.54v.37h1.54v-.37ZM196.22,133.17h1.54v-.37h-1.54v.37ZM196.41,132.99v-2.34h-.37v2.34h.37ZM149.4,110.3c5.93-2.72,22.54-9.21,47.51-9.21v-.37c-25.04,0-41.69,6.5-47.66,9.24l.15.33ZM147.57,111.53c.11-.24.29-.42.58-.61.3-.19.7-.37,1.26-.63l-.15-.33c-.55.25-.98.45-1.3.65-.33.21-.56.44-.71.76l.33.16ZM147.83,113.85c-.17-.63-.29-1.09-.34-1.46-.05-.36-.02-.62.09-.86l-.33-.16c-.15.33-.17.66-.12,1.07.05.4.19.88.35,1.5l.36-.1ZM147.83,113.85h0s-.36.09-.36.09h0s.36-.09.36-.09ZM154.9,145.97c-1.18-6.36-3.95-20.6-7.08-32.12l-.36.1c3.12,11.5,5.89,25.73,7.07,32.09l.36-.07ZM155.84,148.62c-.24-.17-.4-.42-.54-.85-.14-.43-.25-1.01-.4-1.81l-.36.07c.15.79.26,1.39.41,1.85.15.46.35.8.68,1.04l.21-.3ZM158.65,148.57c-.79.14-1.37.24-1.82.26-.45.02-.74-.04-.98-.21l-.21.3c.33.23.72.3,1.21.28.48-.02,1.09-.13,1.87-.27l-.06-.36ZM186,143.86c-4.44.66-20.35,3.47-27.35,4.72l.06.36c7.01-1.25,22.91-4.06,27.34-4.71l-.05-.36ZM196.22,132.8c-2.68,0-4.34.64-5.4,1.66-1.05,1.01-1.46,2.36-1.72,3.7-.13.67-.22,1.35-.32,1.98-.11.64-.23,1.23-.42,1.75-.19.52-.45.96-.82,1.29-.37.33-.87.57-1.55.67l.05.36c.75-.11,1.31-.38,1.75-.76.43-.39.72-.88.92-1.44.2-.55.33-1.18.44-1.82.11-.65.19-1.31.32-1.97.25-1.32.65-2.57,1.61-3.5.96-.92,2.51-1.56,5.14-1.56v-.37ZM244.66,110.13l.08-.17h0s-.08.17-.08.17ZM246.58,111.46l.17-.08h0s-.17.08-.17.08ZM246.34,113.9l-.18-.05h0s.18.05.18.05ZM246.34,113.9l.18.05h0s-.18-.05-.18-.05ZM239.26,146l.18.03-.18-.03ZM238.25,148.77l-.1-.15.1.15ZM235.31,148.75l-.03.18.03-.18ZM207.96,144.04l-.03.18.03-.18ZM149.33,110.13l-.08-.17h0s.08.17.08.17ZM147.4,111.46l-.17-.08h0s.17.08.17.08ZM147.65,113.9l-.18.05h0s.18-.05.18-.05ZM147.65,113.9l.18-.05h0s-.18.05-.18.05ZM154.72,146l-.18.03.18-.03ZM155.74,148.77l.1-.15-.1.15ZM158.68,148.75l.03.18h0l-.03-.18ZM186.02,144.04l.03.18h0l-.03-.18Z",
	},
];

export const customMapStyle = [
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [
			{
				color: "#e9e9e9",
			},
			{
				lightness: 17,
			},
		],
	},
	{
		featureType: "landscape",
		elementType: "geometry",
		stylers: [
			{
				color: "#f5f5f5",
			},
			{
				lightness: 20,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.fill",
		stylers: [
			{
				color: "#ffffff",
			},
			{
				lightness: 17,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.stroke",
		stylers: [
			{
				color: "#ffffff",
			},
			{
				lightness: 29,
			},
			{
				weight: 0.2,
			},
		],
	},
	{
		featureType: "road.arterial",
		elementType: "geometry",
		stylers: [
			{
				color: "#ffffff",
			},
			{
				lightness: 18,
			},
		],
	},
	{
		featureType: "road.local",
		elementType: "geometry",
		stylers: [
			{
				color: "#ffffff",
			},
			{
				lightness: 16,
			},
		],
	},
	{
		featureType: "poi",
		elementType: "geometry",
		stylers: [
			{
				color: "#f5f5f5",
			},
			{
				lightness: 21,
			},
		],
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [
			{
				color: "#dedede",
			},
			{
				lightness: 21,
			},
		],
	},
	{
		elementType: "labels.text.stroke",
		stylers: [
			{
				visibility: "on",
			},
			{
				color: "#ffffff",
			},
			{
				lightness: 16,
			},
		],
	},
	{
		elementType: "labels.text.fill",
		stylers: [
			{
				saturation: 36,
			},
			{
				color: "#333333",
			},
			{
				lightness: 40,
			},
		],
	},
	{
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "transit",
		elementType: "geometry",
		stylers: [
			{
				color: "#f2f2f2",
			},
			{
				lightness: 19,
			},
		],
	},
	{
		featureType: "administrative",
		elementType: "geometry.fill",
		stylers: [
			{
				color: "#fefefe",
			},
			{
				lightness: 20,
			},
		],
	},
	{
		featureType: "administrative",
		elementType: "geometry.stroke",
		stylers: [
			{
				color: "#fefefe",
			},
			{
				lightness: 17,
			},
			{
				weight: 1.2,
			},
		],
	},
];

export const centers = [
	{
		centerId: 485,
		centerCode: "2",
		centerName: "Hospitalet de Llobregat",
	},
	{
		centerId: 486,
		centerCode: "3",
		centerName: "Barcelona - Virrey Amat",
	},
	{
		centerId: 487,
		centerCode: "4",
		centerName: "Girona",
	},
	{
		centerId: 488,
		centerCode: "5",
		centerName: "Sabadell",
	},
	{
		centerId: 489,
		centerCode: "6",
		centerName: "Barcelona - Eixample Dret",
	},
	{
		centerId: 490,
		centerCode: "8",
		centerName: "Esplugues de Llobregat",
	},
	{
		centerId: 491,
		centerCode: "9",
		centerName: "Viladecans",
	},
	{
		centerId: 492,
		centerCode: "10",
		centerName: "Vilafranca del Pened\u00e9s",
	},
	{
		centerId: 493,
		centerCode: "12",
		centerName: "Matar\u00f3",
	},
	{
		centerId: 494,
		centerCode: "13",
		centerName: "Barcelona - Poble Nou",
	},
	{
		centerId: 495,
		centerCode: "14",
		centerName: "Terrassa",
	},
	{
		centerId: 496,
		centerCode: "15",
		centerName: "Manresa",
	},
	{
		centerId: 497,
		centerCode: "16",
		centerName: "Barcelona - Eixample Esquerra",
	},
	{
		centerId: 498,
		centerCode: "17",
		centerName: "Igualada - Pau Muntades",
	},
	{
		centerId: 499,
		centerCode: "19",
		centerName: "Granollers",
	},
	{
		centerId: 500,
		centerCode: "20",
		centerName: "Zaragoza - Juan Jos\u00e9 G\u00e1rate-Barrio San Jose",
	},
	{
		centerId: 501,
		centerCode: "21",
		centerName: "Cerdanyola del Vall\u00e8s",
	},
	{
		centerId: 502,
		centerCode: "22",
		centerName: "Sant Boi de Llobregat",
	},
	{
		centerId: 503,
		centerCode: "23",
		centerName: "Vilanova i la Geltr\u00fa",
	},
	{
		centerId: 504,
		centerCode: "24",
		centerName: "Rub\u00ed",
	},
	{
		centerId: 505,
		centerCode: "25",
		centerName: "Reus",
	},
	{
		centerId: 506,
		centerCode: "26",
		centerName: "Sant Feliu de Llobregat",
	},
	{
		centerId: 507,
		centerCode: "27",
		centerName: "Tarragona",
	},
	{
		centerId: 508,
		centerCode: "28",
		centerName: "Mollet del Vall\u00e8s",
	},
	{
		centerId: 509,
		centerCode: "29",
		centerName: "Premi\u00e0 de Dalt",
	},
	{
		centerId: 510,
		centerCode: "50",
		centerName: "Coria del R\u00edo",
	},
	{
		centerId: 511,
		centerCode: "31",
		centerName: "Vigo - Calle Bolivia",
	},
	{
		centerId: 512,
		centerCode: "32",
		centerName: "Sant Cugat del Vall\u00e8s",
	},
	{
		centerId: 513,
		centerCode: "33",
		centerName: "Madrid - Alcal\u00e1",
	},
	{
		centerId: 514,
		centerCode: "34",
		centerName: "Madrid - Nuevos Ministerios",
	},
	{
		centerId: 515,
		centerCode: "37",
		centerName: "A Coru\u00f1a",
	},
	{
		centerId: 516,
		centerCode: "38",
		centerName: "Nigr\u00e1n",
	},
	{
		centerId: 517,
		centerCode: "39",
		centerName: "Alcal\u00e1 de Henares",
	},
	{
		centerId: 518,
		centerCode: "40",
		centerName: "Llanera",
	},
	{
		centerId: 519,
		centerCode: "41",
		centerName: "Gij\u00f3n",
	},
	{
		centerId: 520,
		centerCode: "42",
		centerName: "Oviedo",
	},
	{
		centerId: 521,
		centerCode: "43",
		centerName: "Valencia - Avda. Burjassot",
	},
	{
		centerId: 522,
		centerCode: "44",
		centerName: "Valencia Puerto",
	},
	{
		centerId: 523,
		centerCode: "45",
		centerName: "Pamplona",
	},
	{
		centerId: 524,
		centerCode: "46",
		centerName: "\u00c1vila",
	},
	{
		centerId: 525,
		centerCode: "47",
		centerName: "Burjassot",
	},
	{
		centerId: 526,
		centerCode: "48",
		centerName: "Catarroja",
	},
	{
		centerId: 527,
		centerCode: "49",
		centerName: "Algemes\u00ed",
	},
	{
		centerId: 528,
		centerCode: "371",
		centerName: "Castell\u00f3n",
	},
	{
		centerId: 529,
		centerCode: "53",
		centerName: "Bilbao - Ctra. Basurto",
	},
	{
		centerId: 530,
		centerCode: "55",
		centerName: "Badalona Centro",
	},
	{
		centerId: 531,
		centerCode: "56",
		centerName: "Guadalajara",
	},
	{
		centerId: 532,
		centerCode: "57",
		centerName: "Torrej\u00f3n de Ardoz",
	},
	{
		centerId: 533,
		centerCode: "58",
		centerName: "Portugalete",
	},
	{
		centerId: 534,
		centerCode: "59",
		centerName: "Madrid - Vallecas",
	},
	{
		centerId: 535,
		centerCode: "60",
		centerName: "Blanes",
	},
	{
		centerId: 536,
		centerCode: "61",
		centerName: "Tortosa",
	},
	{
		centerId: 537,
		centerCode: "62",
		centerName: "Santa Coloma de Gramenet",
	},
	{
		centerId: 538,
		centerCode: "64",
		centerName: "El Vendrell",
	},
	{
		centerId: 539,
		centerCode: "65",
		centerName: "Las Palmas",
	},
	{
		centerId: 540,
		centerCode: "66",
		centerName: "Badalona",
	},
	{
		centerId: 541,
		centerCode: "67",
		centerName: "M\u00e1laga",
	},
	{
		centerId: 542,
		centerCode: "68",
		centerName: "M\u00e1laga - Ortega y Gasset",
	},
	{
		centerId: 543,
		centerCode: "69",
		centerName: "Torremolinos",
	},
	{
		centerId: 544,
		centerCode: "70",
		centerName: "Cambrils",
	},
	{
		centerId: 545,
		centerCode: "71",
		centerName: "Badajoz",
	},
	{
		centerId: 546,
		centerCode: "72",
		centerName: "Don Benito",
	},
	{
		centerId: 547,
		centerCode: "73",
		centerName: "Coria",
	},
	{
		centerId: 548,
		centerCode: "74",
		centerName: "El Prat del Llobregat",
	},
	{
		centerId: 549,
		centerCode: "76",
		centerName: "Castelldefels",
	},
	{
		centerId: 550,
		centerCode: "77",
		centerName: "San Fernando",
	},
	{
		centerId: 551,
		centerCode: "78",
		centerName: "Alcorc\u00f3n",
	},
	{
		centerId: 552,
		centerCode: "79",
		centerName: "Badajoz - Luis Movilla",
	},
	{
		centerId: 553,
		centerCode: "82",
		centerName: "Vitoria-Gasteiz",
	},
	{
		centerId: 554,
		centerCode: "83",
		centerName: "Olesa de Montserrat",
	},
	{
		centerId: 555,
		centerCode: "84",
		centerName: "Amorebieta",
	},
	{
		centerId: 556,
		centerCode: "85",
		centerName: "Madrid - Las Rozas",
	},
	{
		centerId: 557,
		centerCode: "86",
		centerName: "C\u00e1ceres",
	},
	{
		centerId: 559,
		centerCode: "89",
		centerName: "Manresa - Saclosa",
	},
	{
		centerId: 560,
		centerCode: "90",
		centerName: "Ibiza Taller de Lunas",
	},
	{
		centerId: 561,
		centerCode: "91",
		centerName: "Berga",
	},
	{
		centerId: 562,
		centerCode: "342",
		centerName: "Lora del R\u00edo",
	},
	{
		centerId: 563,
		centerCode: "93",
		centerName: "Torrent",
	},
	{
		centerId: 564,
		centerCode: "94",
		centerName: "San Vicente del Raspeig",
	},
	{
		centerId: 565,
		centerCode: "95",
		centerName: "Zaragoza - Torrecillas",
	},
	{
		centerId: 566,
		centerCode: "96",
		centerName: "Inca",
	},
	{
		centerId: 567,
		centerCode: "97",
		centerName: "Valls",
	},
	{
		centerId: 568,
		centerCode: "75",
		centerName: "Castilleja de la cuesta",
	},
	{
		centerId: 569,
		centerCode: "99",
		centerName: "Palma de Mallorca",
	},
	{
		centerId: 570,
		centerCode: "104",
		centerName: "Renter\u00eda - Lezo",
	},
	{
		centerId: 571,
		centerCode: "106",
		centerName: "Algeciras",
	},
	{
		centerId: 572,
		centerCode: "108",
		centerName: "Getafe",
	},
	{
		centerId: 573,
		centerCode: "111",
		centerName: "Lleida",
	},
	{
		centerId: 575,
		centerCode: "116",
		centerName: "Lebrija",
	},
	{
		centerId: 576,
		centerCode: "118",
		centerName: "Madrid - Antonio L\u00f3pez",
	},
	{
		centerId: 577,
		centerCode: "120",
		centerName: "C\u00e1rtama Estaci\u00f3n",
	},
	{
		centerId: 578,
		centerCode: "352",
		centerName: "San Gin\u00e9s",
	},
	{
		centerId: 579,
		centerCode: "126",
		centerName: "noia",
	},
	{
		centerId: 580,
		centerCode: "127",
		centerName: "Los Palacios y Villafranca",
	},
	{
		centerId: 581,
		centerCode: "128",
		centerName: "Arteixo",
	},
	{
		centerId: 582,
		centerCode: "507",
		centerName: "Elche",
	},
	{
		centerId: 583,
		centerCode: "508",
		centerName: "Torrevieja",
	},
	{
		centerId: 584,
		centerCode: "137",
		centerName: "San Jos\u00e9 de la Rinconada",
	},
	{
		centerId: 585,
		centerCode: "346",
		centerName: "Sevilla - Juan de Ledesma",
	},
	{
		centerId: 586,
		centerCode: "139",
		centerName: "Aguilar de la Frontera",
	},
	{
		centerId: 587,
		centerCode: "140",
		centerName: "Plasencia",
	},
	{
		centerId: 588,
		centerCode: "144",
		centerName: "Mieres",
	},
	{
		centerId: 589,
		centerCode: "145",
		centerName: "Huesca",
	},
	{
		centerId: 590,
		centerCode: "146",
		centerName: "Santa Cruz de Tenerife",
	},
	{
		centerId: 591,
		centerCode: "349",
		centerName: "El Ejido",
	},
	{
		centerId: 592,
		centerCode: "149",
		centerName: "Requena",
	},
	{
		centerId: 593,
		centerCode: "156",
		centerName: "Porri\u00f1o",
	},
	{
		centerId: 594,
		centerCode: "157",
		centerName: "Santander",
	},
	{
		centerId: 595,
		centerCode: "158",
		centerName: "Granada - Hu\u00e9tor Vega",
	},
	{
		centerId: 596,
		centerCode: "162",
		centerName: "Dos Hermanas",
	},
	{
		centerId: 597,
		centerCode: "163",
		centerName: "Sevilla - Avda Lemos",
	},
	{
		centerId: 598,
		centerCode: "165",
		centerName: "iniesta",
	},
	{
		centerId: 599,
		centerCode: "166",
		centerName: "Granada",
	},
	{
		centerId: 600,
		centerCode: "167",
		centerName: "OLDYuncos",
	},
	{
		centerId: 601,
		centerCode: "512",
		centerName: "M\u00f3stoles",
	},
	{
		centerId: 602,
		centerCode: "170",
		centerName: "Ronda",
	},
	{
		centerId: 603,
		centerCode: "171",
		centerName: "Ag\u00fcimes",
	},
	{
		centerId: 604,
		centerCode: "172",
		centerName: "Cangas de Morrazo",
	},
	{
		centerId: 605,
		centerCode: "173",
		centerName: "Albacete",
	},
	{
		centerId: 606,
		centerCode: "178",
		centerName: "Soria",
	},
	{
		centerId: 607,
		centerCode: "179",
		centerName: "Burgos",
	},
	{
		centerId: 608,
		centerCode: "182",
		centerName: "Avil\u00e9s",
	},
	{
		centerId: 609,
		centerCode: "183",
		centerName: "Bergondo",
	},
	{
		centerId: 610,
		centerCode: "185",
		centerName: "Conil de la Frontera",
	},
	{
		centerId: 611,
		centerCode: "189",
		centerName: "Aranjuez",
	},
	{
		centerId: 612,
		centerCode: "511",
		centerName: "Vilagarc\u00eda de Arousa",
	},
	{
		centerId: 613,
		centerCode: "194",
		centerName: "Jumilla",
	},
	{
		centerId: 614,
		centerCode: "195",
		centerName: "Valladolid Estaci\u00f3n",
	},
	{
		centerId: 615,
		centerCode: "197",
		centerName: "C\u00f3rdoba - Metal\u00fargicos",
	},
	{
		centerId: 616,
		centerCode: "198",
		centerName: "C\u00f3rdoba - Avda. Carlos III",
	},
	{
		centerId: 617,
		centerCode: "201",
		centerName: "Molina de Segura",
	},
	{
		centerId: 618,
		centerCode: "202",
		centerName: "Lorca",
	},
	{
		centerId: 619,
		centerCode: "203",
		centerName: "Murcia",
	},
	{
		centerId: 620,
		centerCode: "204",
		centerName: "Cartagena",
	},
	{
		centerId: 621,
		centerCode: "210",
		centerName: "\u00dabeda",
	},
	{
		centerId: 622,
		centerCode: "211",
		centerName: "Sanl\u00facar de Barrameda",
	},
	{
		centerId: 623,
		centerCode: "212",
		centerName: "Hu\u00e9rcal de Almeria",
	},
	{
		centerId: 624,
		centerCode: "213",
		centerName: "Guadalajara - Francisco Aritio",
	},
	{
		centerId: 625,
		centerCode: "214",
		centerName: "Priego de C\u00f3rdoba",
	},
	{
		centerId: 626,
		centerCode: "216",
		centerName: "Zamora",
	},
	{
		centerId: 627,
		centerCode: "219",
		centerName: "parla",
	},
	{
		centerId: 628,
		centerCode: "220",
		centerName: "Rivas Vaciamadrid",
	},
	{
		centerId: 629,
		centerCode: "221",
		centerName: "Lucena del Puerto",
	},
	{
		centerId: 630,
		centerCode: "225",
		centerName: "Carmona",
	},
	{
		centerId: 631,
		centerCode: "227",
		centerName: "San Sebasti\u00e1n de los Reyes",
	},
	{
		centerId: 632,
		centerCode: "228",
		centerName: "Valencia - Avda. San Vicente",
	},
	{
		centerId: 633,
		centerCode: "229",
		centerName: "Albox",
	},
	{
		centerId: 634,
		centerCode: "231",
		centerName: "Lucena",
	},
	{
		centerId: 635,
		centerCode: "232",
		centerName: "cuenca",
	},
	{
		centerId: 636,
		centerCode: "234",
		centerName: "Ciempozuelos",
	},
	{
		centerId: 637,
		centerCode: "236",
		centerName: "\u00c1guilas",
	},
	{
		centerId: 638,
		centerCode: "237",
		centerName: "Manacor",
	},
	{
		centerId: 639,
		centerCode: "239",
		centerName: "\u00dabeda 2",
	},
	{
		centerId: 640,
		centerCode: "240",
		centerName: "M\u00e9rida",
	},
	{
		centerId: 641,
		centerCode: "241",
		centerName: "Almer\u00eda",
	},
	{
		centerId: 642,
		centerCode: "242",
		centerName: "Cartaya",
	},
	{
		centerId: 643,
		centerCode: "244",
		centerName: "Quart de Poblet",
	},
	{
		centerId: 644,
		centerCode: "245",
		centerName: "Villamart\u00edn",
	},
	{
		centerId: 645,
		centerCode: "246",
		centerName: "Alcal\u00e1 de Guada\u00edra",
	},
	{
		centerId: 646,
		centerCode: "248",
		centerName: "Roquetas de Mar",
	},
	{
		centerId: 647,
		centerCode: "339",
		centerName: "Le\u00f3n",
	},
	{
		centerId: 648,
		centerCode: "252",
		centerName: "Montoro",
	},
	{
		centerId: 649,
		centerCode: "253",
		centerName: "M\u00e1laga Playa",
	},
	{
		centerId: 650,
		centerCode: "254",
		centerName: "Mora",
	},
	{
		centerId: 651,
		centerCode: "255",
		centerName: "ponferrada-cerrado",
	},
	{
		centerId: 652,
		centerCode: "258",
		centerName: "Amposta",
	},
	{
		centerId: 653,
		centerCode: "261",
		centerName: "zaragoza3",
	},
	{
		centerId: 654,
		centerCode: "262",
		centerName: "Valdemoro",
	},
	{
		centerId: 655,
		centerCode: "264",
		centerName: "Martorell",
	},
	{
		centerId: 656,
		centerCode: "265",
		centerName: "Cieza",
	},
	{
		centerId: 657,
		centerCode: "268",
		centerName: "Talavera de la Reina",
	},
	{
		centerId: 658,
		centerCode: "269",
		centerName: "Vigo - Avda. Camelias",
	},
	{
		centerId: 659,
		centerCode: "270",
		centerName: "Motril",
	},
	{
		centerId: 660,
		centerCode: "271",
		centerName: "Caravaca de la Cruz",
	},
	{
		centerId: 661,
		centerCode: "272",
		centerName: "Estepona",
	},
	{
		centerId: 662,
		centerCode: "273",
		centerName: "Sarria",
	},
	{
		centerId: 663,
		centerCode: "367",
		centerName: "Viveiro",
	},
	{
		centerId: 664,
		centerCode: "368",
		centerName: "Lugo - San Isidro Labrador",
	},
	{
		centerId: 665,
		centerCode: "277",
		centerName: "La Carlota",
	},
	{
		centerId: 666,
		centerCode: "278",
		centerName: "Salamanca",
	},
	{
		centerId: 667,
		centerCode: "280",
		centerName: "Sanxenxo",
	},
	{
		centerId: 668,
		centerCode: "282",
		centerName: "Aracena",
	},
	{
		centerId: 669,
		centerCode: "500",
		centerName: "Sevilla Los Remedios",
	},
	{
		centerId: 670,
		centerCode: "284",
		centerName: "Aranda de Duero",
	},
	{
		centerId: 671,
		centerCode: "285",
		centerName: "Almer\u00eda Altamira",
	},
	{
		centerId: 672,
		centerCode: "286",
		centerName: "Figueres",
	},
	{
		centerId: 673,
		centerCode: "287",
		centerName: "Carballo",
	},
	{
		centerId: 674,
		centerCode: "288",
		centerName: "Ordes",
	},
	{
		centerId: 675,
		centerCode: "506",
		centerName: "Vic",
	},
	{
		centerId: 676,
		centerCode: "290",
		centerName: "Manzanares",
	},
	{
		centerId: 677,
		centerCode: "291",
		centerName: "Ciudad Real",
	},
	{
		centerId: 678,
		centerCode: "363",
		centerName: "Puerto de Sagunto",
	},
	{
		centerId: 679,
		centerCode: "369",
		centerName: "T\u00e1rrega",
	},
	{
		centerId: 680,
		centerCode: "294",
		centerName: "Donosti - San Sebasti\u00e1n",
	},
	{
		centerId: 681,
		centerCode: "295",
		centerName: "Utrera",
	},
	{
		centerId: 682,
		centerCode: "297",
		centerName: "Campohermoso",
	},
	{
		centerId: 683,
		centerCode: "301",
		centerName: "Jerez de la Frontera",
	},
	{
		centerId: 684,
		centerCode: "302",
		centerName: "Torrelavega",
	},
	{
		centerId: 685,
		centerCode: "303",
		centerName: "Bilbao",
	},
	{
		centerId: 686,
		centerCode: "304",
		centerName: "Melilla",
	},
	{
		centerId: 687,
		centerCode: "501",
		centerName: "Osuna",
	},
	{
		centerId: 688,
		centerCode: "307",
		centerName: "A Coru\u00f1a - La Grela",
	},
	{
		centerId: 689,
		centerCode: "308",
		centerName: "Ferrol",
	},
	{
		centerId: 690,
		centerCode: "309",
		centerName: "Pontevedra",
	},
	{
		centerId: 691,
		centerCode: "310",
		centerName: "Lugo - Ronda Das Fonti\u00f1as",
	},
	{
		centerId: 692,
		centerCode: "311",
		centerName: "Ribadeo",
	},
	{
		centerId: 693,
		centerCode: "312",
		centerName: "Santiago de Compostela",
	},
	{
		centerId: 694,
		centerCode: "362",
		centerName: "Mah\u00f3n - Menorca",
	},
	{
		centerId: 695,
		centerCode: "314",
		centerName: "Valladolid Relatores",
	},
	{
		centerId: 696,
		centerCode: "315",
		centerName: "Huelva",
	},
	{
		centerId: 697,
		centerCode: "316",
		centerName: "Vera",
	},
	{
		centerId: 698,
		centerCode: "317",
		centerName: "Canals - X\u00e0tiva",
	},
	{
		centerId: 699,
		centerCode: "319",
		centerName: "Toledo",
	},
	{
		centerId: 700,
		centerCode: "320",
		centerName: "Laredo",
	},
	{
		centerId: 701,
		centerCode: "513",
		centerName: "Coslada",
	},
	{
		centerId: 702,
		centerCode: "322",
		centerName: "Orihuela",
	},
	{
		centerId: 703,
		centerCode: "323",
		centerName: "Villafranca de los Barros",
	},
	{
		centerId: 704,
		centerCode: "324",
		centerName: "Orense",
	},
	{
		centerId: 705,
		centerCode: "325",
		centerName: "Madrid - Bravo Murillo",
	},
	{
		centerId: 706,
		centerCode: "326",
		centerName: "Linares",
	},
	{
		centerId: 707,
		centerCode: "327",
		centerName: "Palau-Solit\u00e0 i Plegamans",
	},
	{
		centerId: 708,
		centerCode: "328",
		centerName: "Castuera",
	},
	{
		centerId: 709,
		centerCode: "329",
		centerName: "Arganda del Rey",
	},
	{
		centerId: 710,
		centerCode: "330",
		centerName: "Candeleda",
	},
	{
		centerId: 711,
		centerCode: "331",
		centerName: "B\u00e9jar",
	},
	{
		centerId: 712,
		centerCode: "332",
		centerName: "Navalcarnero",
	},
	{
		centerId: 713,
		centerCode: "514",
		centerName: "Azuquera de Henares",
	},
	{
		centerId: 714,
		centerCode: "300",
		centerName: "El Puerto de Santa Mar\u00eda",
	},
	{
		centerId: 715,
		centerCode: "335",
		centerName: "Antequera",
	},
	{
		centerId: 716,
		centerCode: "336",
		centerName: "Benicarl\u00f2",
	},
	{
		centerId: 717,
		centerCode: "337",
		centerName: "Alzira",
	},
	{
		centerId: 718,
		centerCode: "510",
		centerName: "C\u00f3rdoba",
	},
	{
		centerId: 720,
		centerCode: "341",
		centerName: "Leon Lastra",
	},
	{
		centerId: 722,
		centerCode: "81",
		centerName: "Sevilla Norte",
	},
	{
		centerId: 723,
		centerCode: "18",
		centerName: "Galapagar",
	},
	{
		centerId: 724,
		centerCode: "340",
		centerName: "Pinto",
	},
	{
		centerId: 725,
		centerCode: "344",
		centerName: "Montblanc",
	},
	{
		centerId: 726,
		centerCode: "345",
		centerName: "\u00c9cija",
	},
	{
		centerId: 727,
		centerCode: "36",
		centerName: "Atocha",
	},
	{
		centerId: 728,
		centerCode: "347",
		centerName: "Ribarroja de Turia",
	},
	{
		centerId: 729,
		centerCode: "54",
		centerName: "La Felguera (Langreo)",
	},
	{
		centerId: 730,
		centerCode: "80",
		centerName: "Zaragoza - Avenida de la hispanidad",
	},
	{
		centerId: 731,
		centerCode: "353",
		centerName: "Palencia",
	},
	{
		centerId: 732,
		centerCode: "59",
		centerName: "Madrid - vallecas",
	},
	{
		centerId: 733,
		centerCode: "343",
		centerName: "Balaguer",
	},
	{
		centerId: 734,
		centerCode: "348",
		centerName: "X\u00e0tiva",
	},
	{
		centerId: 735,
		centerCode: "351",
		centerName: "Fraga",
	},
	{
		centerId: 736,
		centerCode: "85",
		centerName: "Las Rozas",
	},
	{
		centerId: 737,
		centerCode: "354",
		centerName: "Ponferrada",
	},
	{
		centerId: 738,
		centerCode: "504",
		centerName: "Boadilla del Monte",
	},
	{
		centerId: 739,
		centerCode: "505",
		centerName: "Guadalajara - Calle M\u00e9jico",
	},
	{
		centerId: 742,
		centerCode: "357",
		centerName: "Villarobledo",
	},
	{
		centerId: 754,
		centerCode: "334",
		centerName: "El Puerto de Santa Mar\u00eda",
	},
	{
		centerId: 755,
		centerCode: "356",
		centerName: "Cuenca",
	},
	{
		centerId: 756,
		centerCode: "356",
		centerName: "Cuenca",
	},
	{
		centerId: 757,
		centerCode: "88",
		centerName: "Fuenlabrada",
	},
	{
		centerId: 758,
		centerCode: "92",
		centerName: "Villaverde",
	},
	{
		centerId: 759,
		centerCode: "380",
		centerName: "Legan\u00e9s",
	},
	{
		centerId: 762,
		centerCode: "358",
		centerName: "Sesena",
	},
	{
		centerId: 763,
		centerCode: "361",
		centerName: "Manacor",
	},
	{
		centerId: 764,
		centerCode: "364",
		centerName: "Almer\u00eda",
	},
	{
		centerId: 765,
		centerCode: "359",
		centerName: "Mejorada del Campo_0",
	},
	{
		centerId: 766,
		centerCode: "515",
		centerName: "Vigo - Avenida Camelias",
	},
	{
		centerId: 767,
		centerCode: "516",
		centerName: "Alcal\u00e1 de Henares",
	},
	{
		centerId: 768,
		centerCode: "517",
		centerName: "Torrej\u00f3n de Ardoz",
	},
	{
		centerId: 769,
		centerCode: "503",
		centerName: "Hospitalet Avda. Carrilet",
	},
	{
		centerId: 770,
		centerCode: "519",
		centerName: "BILBAO FONTECHA",
	},
	{
		centerId: 771,
		centerCode: "520",
		centerName: "Ponferrada",
	},
	{
		centerId: 772,
		centerCode: "521",
		centerName: "Santiago de Compostela",
	},
	{
		centerId: 773,
		centerCode: "522",
		centerName: "Ordes",
	},
	{
		centerId: 774,
		centerCode: "360",
		centerName: "ALHAUR\u00cdN DE LA TORRE",
	},
	{
		centerId: 775,
		centerCode: "502",
		centerName: "Alicante",
	},
	{
		centerId: 776,
		centerCode: "518",
		centerName: "Vallecas Asamblea",
	},
	{
		centerId: 777,
		centerCode: "523",
		centerName: "Navalcarnero Beatas",
	},
	{
		centerId: 778,
		centerCode: "524",
		centerName: "Alcorc\u00f3n Artesanos",
	},
	{
		centerId: 779,
		centerCode: "365",
		centerName: "Olesa de Montserrat",
	},
	{
		centerId: 780,
		centerCode: "366",
		centerName: "Martorell",
	},
	{
		centerId: 781,
		centerCode: "23333243333233335323334333323323333334636343423334",
		centerName: "titleEs updated",
	},
	{
		centerId: 782,
		centerCode: "355",
		centerName: "INIESTA",
	},
	{
		centerId: 783,
		centerCode: "525",
		centerName: "Sabadell Brutau",
	},
	{
		centerId: 784,
		centerCode: "376",
		centerName: "CAMPOHERMOSO",
	},
	{
		centerId: 785,
		centerCode: "370",
		centerName: "Madrid el Pilar",
	},
	{
		centerId: 786,
		centerCode: "298",
		centerName: "Mazarron",
	},
	{
		centerId: 787,
		centerCode: "372",
		centerName: "Yuncos",
	},
	{
		centerId: 788,
		centerCode: "374",
		centerName: "Mejorada del Campo",
	},
	{
		centerId: 789,
		centerCode: "375",
		centerName: "Onda",
	},
];

export const brandsVehicle = [
	{
		id: 1,
		name: "Toyota",
		models: [
			"Corolla",
			"Camry",
			"Rav4",
			"Highlander",
			"Prius",
			"Tacoma",
			"Tundra",
		],
	},
	{
		id: 2,
		name: "Honda",
		models: [
			"Civic",
			"Accord",
			"CR-V",
			"Pilot",
			"HR-V",
			"Odyssey",
			"Ridgeline",
		],
	},
	{
		id: 3,
		name: "Ford",
		models: [
			"F-150",
			"Mustang",
			"Explorer",
			"Escape",
			"Bronco",
			"Edge",
			"Maverick",
		],
	},
	{
		id: 4,
		name: "Chevrolet",
		models: [
			"Silverado",
			"Malibu",
			"Equinox",
			"Traverse",
			"Tahoe",
			"Camaro",
			"Blazer",
		],
	},
	{
		id: 5,
		name: "Nissan",
		models: [
			"Altima",
			"Sentra",
			"Rogue",
			"Pathfinder",
			"Frontier",
			"Maxima",
			"Titan",
		],
	},
	{
		id: 6,
		name: "BMW",
		models: ["Series 3", "Series 5", "Series 7", "X3", "X5", "Z4", "M4"],
	},
	{
		id: 7,
		name: "Mercedes-Benz",
		models: [
			"C-Class",
			"E-Class",
			"S-Class",
			"GLA",
			"GLC",
			"GLE",
			"G-Class",
		],
	},
	{
		id: 8,
		name: "Audi",
		models: ["A3", "A4", "A6", "Q3", "Q5", "Q7", "TT"],
	},
	{
		id: 9,
		name: "Hyundai",
		models: [
			"Elantra",
			"Sonata",
			"Tucson",
			"Santa Fe",
			"Palisade",
			"Kona",
			"Veloster",
		],
	},
	{
		id: 10,
		name: "Kia",
		models: [
			"Rio",
			"Forte",
			"Optima",
			"Sorento",
			"Sportage",
			"Telluride",
			"Stinger",
		],
	},
];

export const SHOW_DATE_CELLS_BEFORE_MONTH_START = false;

export const eventResultStatusCodesMapfre = {
	SUCCESS: "200",
	CALL_CENTER: "201",
	IN_PROGRESS: "202",
	ERROR_4XX: "4XX",
	ERROR_5XX: "5XX",
};
